import AsyncStorage from '@react-native-async-storage/async-storage';
import type { ReceiptPrintMode } from '../domain/printConfig';

const STORAGE_KEY = '@vuelto/receipt_print_last_status';

/**
 * Último resultado de impresión por sucursal — persiste entre sesiones para
 * que Dispositivos pueda mostrar "la última salió por vista previa (sin
 * corte)" aunque el toast post-cobro ya no esté.
 */
export type LastPrintStatus = {
  at: number;
  transport: ReceiptPrintMode;
  /** Presente cuando el agente falló y el job cayó a vista previa. */
  fallbackWarning?: string;
};

type StoredMap = Record<string, LastPrintStatus>;

async function readMap(): Promise<StoredMap> {
  try {
    const raw = await AsyncStorage.getItem(STORAGE_KEY);
    if (!raw) return {};
    const parsed = JSON.parse(raw) as unknown;
    return typeof parsed === 'object' && parsed !== null && !Array.isArray(parsed)
      ? (parsed as StoredMap)
      : {};
  } catch {
    return {};
  }
}

export async function recordPrintOutcome(
  branchId: string,
  status: { transport: ReceiptPrintMode; fallbackWarning?: string },
): Promise<void> {
  if (!branchId.trim()) return;
  try {
    const map = await readMap();
    map[branchId] = { at: Date.now(), ...status };
    await AsyncStorage.setItem(STORAGE_KEY, JSON.stringify(map));
  } catch {
    // best-effort: el estado es informativo, nunca bloquea el cobro
  }
}

export async function getLastPrintStatus(branchId: string): Promise<LastPrintStatus | null> {
  if (!branchId.trim()) return null;
  const map = await readMap();
  const s = map[branchId];
  return s && typeof s.at === 'number' ? s : null;
}
